
import { Injectable } from '@angular/core';

import { SingleUserComponent } from '../singleuser/singleuser.component';
import { UserSettingsComponent } from '../usersettings/usersettings.component';
import { WellsComponent } from '../wells/wells.component';
import { AddWellComponent } from '../addwell/addwell.component';



@Injectable()
export class ComponentRefService   {
    public singleuser: null | SingleUserComponent = null;
    public wells: null | WellsComponent = null;
    public userSetting: null | UserSettingsComponent = null;
    public addwell: null | AddWellComponent = null;

    constructor() { }

   
}
